<template>
  <div class="board">
    <div class="board-head">
      <div>
        <div class="board-title">面试时间表</div>
        <div class="board-sub">按自然周查看每日面试安排</div>
      </div>
    </div>
    <div class="board-bar">
      <div>
        <div class="board-range">{{ rangeLabel }}</div>
        <div class="board-stat">
          本周共 {{ stats.total }} 场已安排面试 · {{ stats.confirmed }} 场已确定 · {{ stats.unbooked }} 待预约 ·
          空格点击 + 新增 · 已有面试的格子可再点 + 叠加
        </div>
      </div>
      <div class="board-nav">
        <Button size="small" icon="chevron-left" @click="moveWeek(-7)"></Button>
        <Button size="small" @click="goThisWeek">本周</Button>
        <Button size="small" icon="chevron-right" @click="moveWeek(7)"></Button>
        <Button size="small" icon="refresh" :loading="loading" @click="load"></Button>
      </div>
    </div>
    <div class="board-grid-wrap">
      <Spin fix v-if="loading"></Spin>
      <div class="board-grid">
        <div class="cell cell-head cell-time">Time</div>
        <div v-for="(day, i) in weekDays" :key="day.ymd" class="cell cell-head" :class="{'is-today': day.ymd === todayYmd}">
          <div>{{ dayLabels[i] }}</div>
          <div class="cell-date">{{ day.md }}</div>
        </div>
        <template v-for="ts in slots">
          <div class="cell cell-time" :key="'t' + ts.startMin">{{ ts.label }}</div>
          <div v-for="(day, dayIdx) in weekDays" :key="dayIdx + '-' + ts.startMin" class="cell cell-body">
            <button v-if="!slotItems(dayIdx, ts.startMin).length" type="button" class="slot-add"
              title="新增面试" @click="openAdd(day, ts.startMin)">+</button>
            <template v-else>
              <div v-for="t in slotItems(dayIdx, ts.startMin)" :key="t.tchId" class="slot-card"
                :class="{'is-unbooked': isUnbooked(t)}" @click="$emit('open-tch', t)">
                <a class="slot-clear" title="清除此时段" @click.stop="clear(t)"><Icon type="close"></Icon></a>
                <div class="slot-name" :title="t.tchId + ' ' + nameOf(t)">{{ t.tchId }} {{ nameOf(t) }}</div>
                <div class="slot-state">{{ isUnbooked(t) ? '未预约 / Not booked' : '已确定 / Confirmed' }}</div>
              </div>
              <button type="button" class="slot-add is-more" title="再新增一位" @click="openAdd(day, ts.startMin)">+</button>
            </template>
          </div>
        </template>
      </div>
      <div class="board-outside" v-if="outsideItems.length">
        <span class="outside-title">不在 14:00-21:30 时段内的面试：</span>
        <Tag v-for="t in outsideItems" :key="t.tchId" closable @on-close="clear(t)">
          <a @click="$emit('open-tch', t)">{{ t.tchId }} {{ nameOf(t) }}</a> {{ t.interviewTime }}
        </Tag>
      </div>
    </div>

    <Modal v-model="addVisible" title="安排面试到此时段" :mask-closable="false">
      <p class="add-slot-text" v-if="addSlot">{{ addSlot.ymd }} · {{ addSlot.label }}</p>
      <div class="add-label">选择老师</div>
      <Select v-model="pickedTchId" filterable transfer placeholder="请选择待面试老师">
        <Option v-for="t in candidates" :key="t.tchId" :value="t.tchId" :label="t.tchId + ' · ' + nameOf(t)">
          {{ t.tchId }} · {{ nameOf(t) }}{{ t.interviewTime ? '（已有安排，将改期）' : '' }}
        </Option>
      </Select>
      <div slot="footer">
        <Button type="text" @click="addVisible = false">取消</Button>
        <Button type="primary" :loading="saving" @click="confirmAdd">确认安排</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { tchName } from './recruitConst'

const SLOT_START = 14 * 60
const SLOT_END = 21 * 60 + 30
const SLOT_STEP = 30

function pad2 (n) {
  return n < 10 ? '0' + n : String(n)
}

function hm (minutes) {
  return pad2(Math.floor(minutes / 60)) + ':' + pad2(minutes % 60)
}

export default {
  name: 'RecruitScheduleBoard',
  data () {
    let slots = []
    for (let m = SLOT_START; m + SLOT_STEP <= SLOT_END; m += SLOT_STEP) {
      slots.push({startMin: m, label: hm(m) + '-' + hm(m + SLOT_STEP)})
    }
    return {
      dayLabels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      slots: slots,
      weekStart: this.$moment().startOf('isoWeek').format('YYYY-MM-DD'),
      todayYmd: this.$moment().format('YYYY-MM-DD'),
      scheduled: [],
      unscheduled: [],
      loading: false,
      addVisible: false,
      addSlot: null,
      pickedTchId: null,
      saving: false
    }
  },
  computed: {
    weekDays () {
      let days = []
      for (let i = 0; i < 7; i++) {
        let d = this.$moment(this.weekStart, 'YYYY-MM-DD').add(i, 'days')
        days.push({ymd: d.format('YYYY-MM-DD'), md: d.format('M/D')})
      }
      return days
    },
    rangeLabel () {
      return this.weekDays[0].ymd + ' - ' + this.weekDays[6].ymd
    },
    slotMap () {
      let map = {}
      let dayIndex = {}
      this.weekDays.forEach(function (d, i) {
        dayIndex[d.ymd] = i
      })
      this.scheduled.forEach((t) => {
        let pos = this.slotPos(t, dayIndex)
        if (!pos || pos.outside) {
          return
        }
        let key = pos.dayIdx + '-' + pos.startMin
        if (!map[key]) {
          map[key] = []
        }
        map[key].push(t)
      })
      return map
    },
    outsideItems () {
      let dayIndex = {}
      this.weekDays.forEach(function (d, i) {
        dayIndex[d.ymd] = i
      })
      return this.scheduled.filter((t) => {
        let pos = this.slotPos(t, dayIndex)
        return pos && pos.outside
      })
    },
    stats () {
      let total = this.scheduled.length
      let unbooked = this.scheduled.filter(this.isUnbooked).length
      return {total: total, unbooked: unbooked, confirmed: total - unbooked}
    },
    candidates () {
      let seen = {}
      let list = []
      this.unscheduled.concat(this.scheduled).forEach(function (t) {
        if (t && !seen[t.tchId]) {
          seen[t.tchId] = true
          list.push(t)
        }
      })
      return list
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    nameOf (t) {
      return tchName(t)
    },
    isUnbooked (t) {
      let st = t.interviewStatus || 'pending'
      return st === 'pending' || st === 'failed'
    },
    slotPos (t, dayIndex) {
      if (!t || !t.interviewTime) {
        return null
      }
      let m = this.$moment(t.interviewTime, 'YYYY-MM-DD HH:mm:ss')
      if (!m.isValid()) {
        return null
      }
      let idx = dayIndex[m.format('YYYY-MM-DD')]
      if (idx === undefined) {
        return null
      }
      let minutes = m.hours() * 60 + m.minutes()
      let aligned = Math.floor(minutes / SLOT_STEP) * SLOT_STEP
      return {dayIdx: idx, startMin: aligned, outside: aligned < SLOT_START || aligned >= SLOT_END}
    },
    slotItems (dayIdx, startMin) {
      return this.slotMap[dayIdx + '-' + startMin] || []
    },
    moveWeek (days) {
      this.weekStart = this.$moment(this.weekStart, 'YYYY-MM-DD').add(days, 'days').format('YYYY-MM-DD')
      this.load()
    },
    goThisWeek () {
      this.weekStart = this.$moment().startOf('isoWeek').format('YYYY-MM-DD')
      this.load()
    },
    load () {
      this.loading = true
      this.$http.post('/tchRecruit/interview/schedule-board', {weekStart: this.weekStart}, {silent: true}).then((res) => {
        if (res && res.status === 'ok') {
          let data = res.data || {}
          this.scheduled = data.scheduled || []
          this.unscheduled = data.unscheduled || []
        } else {
          this.scheduled = []
          this.unscheduled = []
          this.$Message.error((res && res.msg) || '时间表加载失败')
        }
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    },
    openAdd (day, startMin) {
      this.addSlot = {
        ymd: day.ymd,
        startMin: startMin,
        label: hm(startMin) + '–' + hm(startMin + SLOT_STEP)
      }
      this.pickedTchId = null
      this.addVisible = true
    },
    confirmAdd () {
      if (!this.pickedTchId) {
        this.$Message.error('请选择老师')
        return
      }
      let time = this.addSlot.ymd + ' ' + hm(this.addSlot.startMin) + ':00'
      this.saving = true
      this.$http.post('/tchRecruit/interview/schedule', {tchId: this.pickedTchId, interviewTime: time}, {silent: true}).then((res) => {
        if (res && res.status === 'ok') {
          this.$Message.success('已安排面试')
          this.addVisible = false
          this.load()
          this.$emit('on-change')
        } else {
          this.$Message.error((res && res.msg) || '安排失败')
        }
      }).catch(() => {}).finally(() => {
        this.saving = false
      })
    },
    clear (t) {
      this.$Modal.confirm({
        title: '清除面试时段',
        content: '确定清除 ' + t.tchId + ' ' + this.nameOf(t) + ' 的面试时间？面试状态将回到待安排。',
        onOk: () => {
          this.$http.post('/tchRecruit/interview/clear-interview', {tchId: t.tchId}, {silent: true}).then((res) => {
            if (res && res.status === 'ok') {
              this.$Message.success('已清除面试时段')
              this.load()
              this.$emit('on-change')
            } else {
              this.$Message.error((res && res.msg) || '清除失败')
            }
          }).catch(() => {})
        }
      })
    }
  }
}
</script>
<style scoped>
.board { position: relative; background: #fff; border: 1px solid #e9eaec; border-radius: 6px; }
.board-head { padding: 14px 20px; border-bottom: 1px solid #e9eaec; }
.board-title { font-size: 16px; font-weight: 700; color: #1c2438; }
.board-sub { margin-top: 2px; font-size: 12px; color: #808695; }
.board-bar { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; padding: 10px 20px; border-bottom: 1px solid #e9eaec; }
.board-range { font-size: 14px; font-weight: 600; color: #303133; }
.board-stat { margin-top: 2px; font-size: 12px; color: #808695; }
.board-nav .ivu-btn + .ivu-btn { margin-left: 4px; }
.board-grid-wrap { position: relative; padding: 12px; overflow-x: auto; }
.board-grid { display: grid; grid-template-columns: 96px repeat(7, minmax(120px, 1fr)); min-width: 940px; border-top: 1px solid #e9eaec; border-left: 1px solid #e9eaec; }
.cell { border-right: 1px solid #e9eaec; border-bottom: 1px solid #e9eaec; }
.cell-head { padding: 6px; background: #f8f8f9; font-size: 12px; font-weight: 600; text-align: center; color: #495060; }
.cell-head.is-today { background: #e8f8f2; color: #0b9e8d; }
.cell-date { font-size: 11px; font-weight: 400; }
.cell-time { display: flex; align-items: center; justify-content: center; padding: 4px; background: #fff; font-size: 11px; color: #657180; }
.cell-head.cell-time { background: #f8f8f9; }
.cell-body { min-height: 64px; padding: 4px; }
.slot-add { display: flex; align-items: center; justify-content: center; width: 100%; height: 56px; border: 1px dashed #dddee1; border-radius: 4px; background: transparent; color: #c5c8ce; font-size: 18px; cursor: pointer; }
.slot-add:hover { border-color: #2d8cf0; color: #2d8cf0; background: #f0f7ff; }
.slot-add.is-more { height: 20px; margin-top: 4px; font-size: 14px; opacity: 0; }
.cell-body:hover .slot-add.is-more { opacity: 1; }
.slot-card { position: relative; padding: 4px 18px 4px 6px; border: 1px solid #dddee1; border-radius: 4px; background: #f3f4f6; cursor: pointer; }
.slot-card + .slot-card { margin-top: 4px; }
.slot-card.is-unbooked { border-color: #ffccc7; background: #fff1f0; }
.slot-clear { position: absolute; top: 2px; right: 4px; color: #9AA3B2; font-size: 12px; }
.slot-clear:hover { color: #ed3f14; }
.slot-name { overflow: hidden; font-size: 11px; font-weight: 600; white-space: nowrap; text-overflow: ellipsis; color: #303133; }
.slot-state { margin-top: 2px; font-size: 10px; color: #19be6b; }
.slot-card.is-unbooked .slot-state { color: #ed3f14; }
.board-outside { margin-top: 10px; font-size: 12px; color: #808695; }
.outside-title { margin-right: 6px; }
.add-slot-text { margin-bottom: 10px; font-size: 13px; color: #808695; }
.add-label { margin-bottom: 6px; font-size: 13px; font-weight: 600; }
</style>



// WEBPACK FOOTER //
// RecruitScheduleBoard.vue?30b3252c